// @flow

import type { Node } from 'react';
import { Component } from 'react';
import { withRouter } from 'react-router-dom';

type Props = {
  children: Node,
  location: string
};

class ScrollToTop extends Component<Props> {

  componentDidUpdate(prevProps: Props) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }

}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/components/ScrollToTop.js